export default __webpack_public_path__ + "static/media/i-lock.2090c837.svg";